/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { X, History } from "lucide-react";
import { formatCurrency } from "../../utils/constants";

const HistoryModal = ({
  selectedPayment,
  showHistoryModal,
  setShowHistoryModal,
}) => {
  return (
    showHistoryModal &&
    selectedPayment && (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
        <div className="bg-card dark:bg-dark-surface rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
          <div className="p-6 border-b border-gray-100 dark:border-dark-border flex justify-between items-center">
            <h3 className="text-lg font-bold text-text dark:text-dark-text flex items-center gap-2">
              <History size={18} /> Payment History
            </h3>
            <button onClick={() => setShowHistoryModal(false)}>
              <X size={20} className="text-gray-400 dark:text-dark-muted" />
            </button>
          </div>
          <div className="p-6 max-h-[400px] overflow-y-auto">
            <div className="relative border-l-2 border-gray-100 dark:border-gray-800 ml-3 space-y-8">
              {/* Chronological start: Invoice Generated */}
              <div className="relative pl-6">
                <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-card dark:bg-dark-surface border-2 border-primary"></div>
                <p className="text-xs text-gray-400 dark:text-dark-muted mb-1">
                  {new Date(
                    selectedPayment.createdAtDate || selectedPayment.createdAt
                  ).toLocaleString()}
                </p>
                <p className="text-sm font-bold text-text dark:text-dark-text">
                  Invoice Generated
                </p>
                <p className="text-xs text-gray-500 dark:text-dark-muted mt-1">
                  Initial amount:{" "}
                  {formatCurrency(selectedPayment.amountToPay || selectedPayment.amount)}
                </p>
              </div>

              {/* Mapped history updates */}
              {(selectedPayment.history || selectedPayment.updateHistory || []).map((event, i) => {
                const amount = Number(event.amountPaid || 0);
                const historyList = selectedPayment.history || selectedPayment.updateHistory || [];
                const totalPaidAfter = event.totalPaidAfterUpdate !== undefined 
                  ? event.totalPaidAfterUpdate 
                  : historyList.slice(0, i + 1).reduce((sum, item) => sum + Number(item.amountPaid || 0), 0);

                return (
                  <div key={event.id || i} className="relative pl-6">
                    <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-card dark:bg-dark-surface border-2 border-primary"></div>
                    <p className="text-xs text-gray-400 dark:text-dark-muted mb-1">
                      {new Date(event.paidAt || event.updatedAt).toLocaleString()}
                    </p>
                    <p className="text-sm font-bold text-text dark:text-dark-text">
                      Paid {formatCurrency(amount)}
                    </p>
                    {event.note && (
                      <p className="text-xs text-gray-500 dark:text-dark-muted mt-1">
                        Note: {event.note}
                      </p>
                    )}
                    <p className="text-xs text-gray-500 dark:text-dark-muted mt-1">
                      by {event.updatedBy?.name || event.recordedBy?.name || "Unknown Admin"}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-dark-muted">
                      Total after: {formatCurrency(totalPaidAfter)}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default HistoryModal;
